export default __webpack_public_path__ + "static/media/sanmat6.3d23335a.jpg";